import React, { useState, useEffect } from 'react';

function PatientInfo({ searchData, handleRowClick }) {
  // searchData가 null 또는 undefined이면 헤더만 렌더링
  if (searchData == null) {
    return (
      <div className="nuser-wrapper">
        <div className="nuser-custom-table">
          <div className="row header3">
            <div className="nurse-search-cell cell-center-align">이름</div>
            <div className="nurse-search-cell cell-center-align">생년월일</div>
            <div className="nurse-search-cell cell-center-align">임신주수</div>
            <div className="nurse-search-cell cell-center-align">담당의사</div>
          </div>
        </div>
        <div className='no-data-span'>
          <span >검색 버튼을 클릭해주세요.</span>
        </div>
      </div>
    );
  } else if(searchData != null && searchData.length == 0){
    return (
      <div className="nuser-wrapper">
        <div className="nuser-custom-table">
          <div className="row header3">
            <div className="nurse-search-cell cell-center-align">이름</div>
            <div className="nurse-search-cell cell-center-align">생년월일</div>
            <div className="nurse-search-cell cell-center-align">임신주수</div>
            <div className="nurse-search-cell cell-center-align">담당의사</div>
          </div>
        </div>
        <div className='no-data-span'>
          <span >조회 결과가 없습니다.</span>
        </div>
      </div>
    );
  } else if(searchData != null && searchData.length > 0){
    // searchData가 있을 때 데이터를 렌더링
    return (
      <div className="nuser-wrapper">
        <div className="nuser-custom-table">
          <div className="row header3">
            <div className="nurse-search-cell cell-center-align">이름</div>
            <div className="nurse-search-cell cell-center-align">생년월일</div>
            <div className="nurse-search-cell cell-center-align">임신주수</div>
            <div className="nurse-search-cell cell-center-align">담당의사</div>
          </div>

          {searchData.map((patient, index) => (
            <div className={`${index % 2 === 0 ? 'row row-hovered nurse-cursor' : 'row-colored nurse-click-style row-hovered nurse-cursor'}`}
              key={patient.patientId} 
              onClick={() => handleRowClick(patient.patientId)}>
              <div className="nurse-search-cell">{patient.patientName}</div>
              <div className="nurse-search-cell">{patient.birthDate}</div>
              <div className="nurse-search-cell cell-center-align">{patient.pregnantWeeks}</div>
              <div className="nurse-search-cell">{patient.doctorName}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default PatientInfo;